import { buildTimeStringFromTimestamp } from '../../time/timeHelper'

export const changeUserPasswordReportDataMapperForPDF = (data) => {
  const header = ['Action Owner', 'Affected User', 'Status', 'Date']
  const parsedData = data.map((report) => {
    return [
      report.emailUser,
      report.activityDetails.userCredentials ? report.activityDetails.userCredentials : '---',
      report.activityDetails.actionResult,
      buildTimeStringFromTimestamp(report.createdAt),
    ]
  })

  return {
    columns: header,
    body: parsedData,
  }
}

export const changeUserPasswordReportDataMapper = (data) => {
  return data.map((report) => {
    return {
      ActionOwner: report.emailUser,
      AffectedUser: report.activityDetails.userCredentials ? report.activityDetails.userCredentials : '---',
      Status: report.activityDetails.actionResult,
      Date: buildTimeStringFromTimestamp(report.createdAt),
    }
  })
}
